import { render, staticRenderFns } from "./recycle-index.vue?vue&type=template&id=4eee3a00"
import script from "./recycle-index.vue?vue&type=script&lang=js"
export * from "./recycle-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports